import * as ngCore from '@angular/core'

import * as layout from '../../../layout'
import { AtnDsTableStore } from '../../store'
import * as embedded from '../embedded'

import * as actions from './actions'

@ngCore.Component({
  imports: [embedded.Component, actions.Component, layout.widget.Component],
  selector: 'widget-container',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  // NOTE: only public for template purposes
  public readonly _store = ngCore.inject(AtnDsTableStore)
}
